import { cva } from '@/styled-system/css';

export const inlineFeedbackIconRecipe = cva({
  variants: {
    tone: {
      critical: {
        color: 'InlineFeedback.critical.icon',
      },
      info: {
        color: 'InlineFeedback.info.icon',
      },
      success: {
        color: 'icon.feedback.success.hero-alt',
      },
      transient: {
        color: 'InlineFeedback.transient.icon',
      },
      warning: {
        color: 'InlineFeedback.warning.icon',
      },
    },
  },
});
